import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  f7,
  Page,
  Fab,
  BlockTitle,
  Icon,
  Block,
  Button,
  Preloader,
  Link,
  Checkbox,
  Navbar,
  Searchbar,
  List,
  ListItem,
  Toggle,
} from "framework7-react";

// Helpers
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getStoreOveralls } from "../actions";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import _ from "lodash";

import MovePopover from "./index/MovePopover";

function mapStateToProps(state) {
  return {
    store_overalls: state.store_overalls,
  };
}

const StoreOverallsIndex = (props) => {
  const [loading, setLoading] = useState(false);
  const [showHidden, setShowHidden] = useState(false);
  const { f7router, store_overalls } = props;

  useEffect(() => {
    f7.preloader.show();
    props.getStoreOveralls(showHidden).then(() => {
      f7.preloader.hide();
    });
  }, [showHidden]);

  useEffect(() => {
    window.selectOverall = (barcode) => selectOverall(barcode);
  }, [store_overalls]);

  const [selectedOveralls, setSelectedOveralls] = useState([]);
  const [missingOveralls, setMissingOveralls] = useState([]);
  const [popoverOpened, setPopoverOpened] = useState(false);

  // Select overall by barcode (scanned or typed)
  // If overall is already selected, unselect it
  const selectOverall = (barcode) => {
    const overall = _.find(store_overalls, (o) => o.barcode == barcode);
    if (!overall) {
      setMissingOveralls((prev) => {
        if (!_.includes(prev, barcode)) {
          return [...prev, barcode];
        } else {
          return prev;
        }
      });
    } else {
      setSelectedOveralls((prev) => {
        if (!_.includes(prev, overall.id)) {
          return [...prev, overall.id];
        } else {
          return prev;
        }
      });
    }
  };

  const deSelectOverall = (barcode) => {
    const overall = _.find(store_overalls, (o) => o.barcode == barcode);
    if (overall) {
      setSelectedOveralls((prev) => _.filter(prev, (id) => id != overall.id));
    } else {
      setMissingOveralls((prev) => _.filter(prev, (b) => b != barcode));
    }
  };

  useEffect(() => {
    setLoading(props.store_overalls.loading);
  }, [props.store_overalls.loading]);

  const readRole = HasRole(
    {
      resource_type: "Store::Overall",
      name: ["read", "moderator"],
    },
    true
  );

  const createRole = HasRole(
    {
      resource_type: "Store::Overall",
      name: ["create", "moderator"],
    },
    true
  );

  const updateRole = HasRole(
    {
      resource_type: "Store::Overall",
      name: ["update", "moderator"],
    },
    true
  );

  if (!readRole) {
    return <NotAuthorized />;
  }

  const selectedOverallsCount = _.size(selectedOveralls);
  const [searchTerm, setSearchTerm] = useState("");
  const displayOveralls = _.filter(store_overalls, (o) => {
    if (searchTerm == "") {
      return true;
    }
    const term = searchTerm.toLowerCase();
    return (
      (o?.employee_name && o.employee_name.toLowerCase().includes(term)) ||
      (o?.status_name && o.status_name.toLowerCase().includes(term)) ||
      (o?.description && o.description.toLowerCase().includes(term)) ||
      (o?.barcode && o.barcode.toLowerCase().includes(term)) ||
      (o?.issue_date && o.issue_date.toLowerCase().includes(term))
    );
  });

  const notSelectedOverallsList = _.filter(displayOveralls, (o) => !_.includes(selectedOveralls, o.id));
  const selectedOverallsList = _.filter(store_overalls, (o) => _.includes(selectedOveralls, o.id));

  return (
    <Page>
      {/* <AppNavbar title="Store Overalls" /> */}

      <Navbar title="Store Overalls" />

      <List>
        <ListItem>
          Show Hidden
          <Toggle
            checked={showHidden}
            onChange={() => {
              setShowHidden(!showHidden);
            }}
          />
        </ListItem>
      </List>

      {loading && <Preloader />}
      {!loading && (
        <Fragment>
          <Block>
            {/* <BlockTitle>Store Overalls</BlockTitle> */}
            <Searchbar
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
            />

            {_.isNotEmpty(missingOveralls) && (
              <Fragment>
                <Block>
                  <div className="grid grid-cols-2 grid-gap">
                    <div>Missing Overalls</div>
                    <div>
                      <Button fill onClick={() => setMissingOveralls([])} round>
                        Clear all
                      </Button>
                    </div>
                  </div>
                </Block>

                <MissingOverallsTable overalls={missingOveralls} setMissingOveralls={setMissingOveralls} />
              </Fragment>
            )}

            {selectedOverallsCount > 0 && (
              <Fragment>
                <BlockTitle>Selected Overalls ({selectedOverallsCount})</BlockTitle>
                <OverallsTable
                  overalls={selectedOverallsList}
                  selectedOveralls={selectedOveralls}
                  selectOverall={selectOverall}
                  deSelectOverall={deSelectOverall}
                />
              </Fragment>
            )}
            <hr />

            <BlockTitle>Unselected Overalls ({_.size(notSelectedOverallsList)})</BlockTitle>
            <OverallsTable
              overalls={notSelectedOverallsList}
              selectedOveralls={selectedOveralls}
              selectOverall={selectOverall}
              deSelectOverall={deSelectOverall}
            />
          </Block>
        </Fragment>
      )}

      {selectedOverallsCount > 0 && (
        <Fab
          position="left-bottom"
          slot="fixed"
          text={`Move ${selectedOverallsCount}`}
          onClick={() => {
            setPopoverOpened(true);
          }}
        >
          <Icon ios="f7:forward_fill" aurora="f7:forward_fill" md="material:forward_fill"></Icon>
        </Fab>
      )}

      <MovePopover
        opened={popoverOpened}
        setOpened={setPopoverOpened}
        selectedOveralls={selectedOveralls}
        setSelectedOveralls={setSelectedOveralls}
      />

      {createRole && (
        <Fab position="right-bottom" slot="fixed" text="New" href="/store/overalls/new">
          <Icon ios="f7:plus" aurora="f7:plus" md="material:add"></Icon>
        </Fab>
      )}
    </Page>
  );
};
export default connect(mapStateToProps, { getStoreOveralls })(StoreOverallsIndex);

const OverallsTable = (props) => {
  const { overalls, selectedOveralls, selectOverall, deSelectOverall } = props;

  const displayOveralls = _.sortBy(overalls, "employee_name");

  return (
    <div className="data-table data-table-init">
      <table>
        <thead>
          <tr>
            <td className="checkbox-cell"></td>
            <th className="label-cell">Employee</th>
            <th className="label-cell">Status</th>
            <th className="label-cell">Garment</th>
            <th className="label-cell">Issue Date</th>
            <th className="label-cell">Barcode</th>
          </tr>
        </thead>
        <tbody>
          {_.map(displayOveralls, (store_overall, i) => {
            const checked = _.includes(selectedOveralls, store_overall.id) ? true : false;
            return (
              <tr key={i}
              
              style={{ backgroundColor: store_overall.hidden ? "#faa2a2" : "" }}
              >
                <td className="checkbox-cell">
                  <Checkbox
                    onChange={(e) => {
                      if (checked) {
                        deSelectOverall(store_overall.barcode);
                      } else {
                        selectOverall(store_overall.barcode);
                      }
                    }}
                    checked={checked}
                  />
                </td>
                <td className="label-cell">{store_overall?.employee_name}</td>
                <td className="label-cell">{store_overall?.status_name}</td>
                <td className="label-cell">{store_overall?.garment_name}</td>
                <td className="label-cell">{moment(store_overall?.issue_date).format("DD/MM/YYYY")}</td>
                <td className="label-cell">{store_overall?.barcode}</td>
                <td>
                  <Link fill href={`/store/overalls/${store_overall.id}/edit`}>
                    Edit
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const MissingOverallsTable = (props) => {
  const { overalls, setMissingOveralls } = props;
  return (
    <div className="data-table data-table-init">
      <table>
        <tbody>
          {_.map(overalls, (barcode, i) => (
            <tr key={i}>
              <td className="label-cell">{barcode}</td>
              <td className="label-cell">
                <Button
                  fill
                  color="red"
                  onClick={() => {
                    props.setMissingOveralls((prev) => _.filter(prev, (b) => b != barcode));
                  }}
                >
                  X
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Block>
        <Button fill href={`/store/overalls/new?barcodes=${overalls.join(",")}`}>
          Create Overalls
        </Button>
      </Block>
    </div>
  );
};
